import apiClient from '../apiClient';
import { POST_EDIT_QUOTATION_URL } from '../apiUrl';

const postEditQuotationApi = (id, data) => {
  return apiClient.post(POST_EDIT_QUOTATION_URL(id), data);
};

export default postEditQuotationApi;
